import { ConfiguratorRequest } from './configurator-request.js'
import { baseUrl } from '@cloudsuite/mosaic-shared/scripts/base-url.js'
import { fetcher } from 'components/shared/fetcher.js'

export const executeConfiguratorRequest = async <T, E>(request: ConfiguratorRequest<T, E>): Promise<T | E> => {
  const url = new URL(request.path, await baseUrl())
  const response = await fetcher.fetch(url, request.init)
  const data: unknown = await parseDataFromResponse(response)

  if (response.ok) return request.parseResponse?.(data) as T

  return request.parseError(response.status, data) as E
}

const parseDataFromResponse = async (response: Response): Promise<unknown> => {
  const nullBodyStatuses = [101, 103, 204, 205, 304]
  if (nullBodyStatuses.includes(response.status)) return null

  const text = await response.text()
  if (!text) return null
  return JSON.parse(text)
}
